import clients from "../client";
const { api } = clients;
export default {
  post: (url, body) => {
    return api.post(url, body);
  },
  // get: (url) => {
  //   return api.get(url);
  // },
  get: (url, options = {}) => {
    return api.get(url, { ...options });
  },
  put: (url, body) => {
    return api.put(url, body);
  },
  deleteData: (url) => {
    return api.delete(url);
  },
  patch: (url, body) => {
    return api.patch(url, body);
  },
};
